import { useNavigate } from 'react-router-dom';
import { animeList } from '@/mocks/anime';

export default function FeaturedAnime() {
  const navigate = useNavigate();
  const featured = animeList.filter((a) => a.rating >= 9.5).slice(0, 6);

  const handleClick = (id: string) => {
    navigate(`/article/${id}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-2">每周精选高分番剧，总有一部适合你</p>
          </div>
          <a
            href="/category/recent"
            onClick={(e) => { e.preventDefault(); navigate('/category/recent'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </a>
        </div>

        <div
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5"
          data-product-shop
        >
          {featured.map((anime) => (
            <div
              key={anime.id}
              className="group cursor-pointer"
              onClick={() => handleClick(anime.id)}
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-100">
                <img
                  src={anime.cover}
                  alt={anime.title}
                  title={`${anime.title} - 高清在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                    {anime.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <p className="text-white text-xs whitespace-nowrap">{anime.episodes}</p>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                {anime.title}
              </h3>
              <div className="flex items-center gap-1.5 mt-1 flex-wrap">
                {anime.tags.slice(0, 2).map((tag) => (
                  <span key={tag} className="text-xs text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 sm:hidden text-center">
          <a
            href="/category/recent"
            onClick={(e) => { e.preventDefault(); navigate('/category/recent'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="inline-flex items-center gap-1 text-sm text-primary-500 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </a>
        </div>
      </div>
    </section>
  );
}